import React from 'react';
import {connect} from "react-redux";
import {
  CABINET_LABELS,
  SIDEBAR_NAVIGATION_3D_CABINET_BUTTONS,
  SIDEBAR_NAVIGATION_CABINET_BUTTONS
} from "../../../../../constants";
import {setSQFTActiveButton, setSQFTMenuOpened} from "../../../../../../../actions/sqftMenuFunctions";
import SqftOptionsRelatedItemList from "./commonParts/SqftOptionsRelatedItemList";
import SQFTFeaturesHeader from "./commonParts/SQFTFeaturesHeader";
import {FormattedMessage} from "react-intl";
import {addCabinetShapeToWorkspace} from "./helpers/addCabinetShapeToWorkspace";
//import SqftOptionsItemList from "./commonParts/SqftOptionsItemList";

const SqftNavigationTall = (props) => {
  const {activeFeature} = props;
  const {menuOpened} = props;
  const expanded = menuOpened === SIDEBAR_NAVIGATION_CABINET_BUTTONS.tall
    || menuOpened === SIDEBAR_NAVIGATION_3D_CABINET_BUTTONS.tall_cabinet_boxes

  return (
    <div className={"content content--left side-level2" + (expanded ? " expanded" : "")}>
      <div className="side-level2__inner ">
        <SQFTFeaturesHeader headerTitle={ <FormattedMessage id={"sqft.navigation.submenu.tallTitle"}/> }
                            partId={CABINET_LABELS.tall_cabinet_boxes}/>
        {expanded ?
          <SqftOptionsRelatedItemList activeFeature={activeFeature}
                                   partId={CABINET_LABELS.tall_cabinet}
                                   //relatedItemsPartId={CABINET_LABELS.tall_cabinet_boxes}
                                   shouldSortByWidth={true}
                                   itemClickCallback={(feature, parentFeature) => {
                                     addCabinetShapeToWorkspace(feature, parentFeature)}
                                   }
          />
        : null}
        {/*{*/}
        {/*  <SqftOptionsItemList activeFeature={activeFeature}*/}
        {/*                       partId={CABINET_LABELS.tall_cabinet_boxes}*/}
        {/*                       parentPartId={CABINET_LABELS.tall_cabinet}*/}
        {/*                       expanded={expanded}*/}
        {/*                       shouldSortByWidth={true}*/}
        {/*                       itemClickCallback={(feature, parentFeature) => {*/}
        {/*                         cabinetWorkspace.cabinetShapes.addShape(feature, parentFeature)}*/}
        {/*                       }*/}
        {/*  />*/}
        {/*}*/}
      </div>
    </div>
  )
};

const mapStateToProps = (store) => {
  const {menuOpened} = store.sqftMenuState;
  const {sqftFromFeature} = store.sqftState;
  return {
    menuOpened,
    activeFeature: sqftFromFeature ? sqftFromFeature.cartFeature : null
  };
};

const mapDispatchToProps = {
  setSQFTMenuOpened,
  setSQFTActiveButton
};


export default connect(mapStateToProps, mapDispatchToProps)(SqftNavigationTall);
